<template>
  <ul class="select-tab">
    <li
      v-for="option in newOptions"
      tabindex="0"
      :key="option.id"
      :id="option.id"
      :title="option.value"
      class="select-tab__option text-18-500"
      :class="getOptionClass(option.id)"
      @click.stop="selectOption(option)"
      @keydown.space.prevent="selectOption(option)"
    >
      <slot name="option" :option="option">
        {{ option.value }}
      </slot>
    </li>
  </ul>
</template>

<script lang="ts">
import type { PropType } from "vue";

import { computed } from "vue";
import { BaseSelectOption } from "../BaseSelect.vue";

export default defineNuxtComponent({
  emits: ["select", "selectOption"],

  props: {
    options: {
      type: Array as PropType<BaseSelectOption[]>,
      required: true,
    },
    // @deprecated
    // Use the `selectedValue` prop
    value: {
      type: String as PropType<string>,
      required: false,
    },
    selectedValue: {
      type: Object as PropType<BaseSelectOption>,

      // Mark it as true after the complete deprecation of the other features
      required: false,
    },
  },
  setup(props, { emit }) {
    // @deprecated
    const selectedOption = computed({
      get() {
        return props.value;
      },
      set(val) {
        emit("select", val);
      },
    });

    const newOptions = computed(() => props.options);

    function selectOption(option: BaseSelectOption): void {
      emit("selectOption", option);
      selectedOption.value = option.id;
    }

    function getOptionClass(id: string) {
      return {
        "select-tab__option_selected": (id === selectedOption.value) || (id === props.selectedValue?.id),
      };
    }

    return {
      newOptions,
      selectOption,
      getOptionClass,
    };
  },
});
</script>
